<template>
  <div>
    <table v-if="displayConditions.length > 0" class="table table-striped">
      <thead>
        <tr>
          <th>{{ $t('filters.list_name') }}</th>
          <th>{{ $t('filters.list_created') }}</th>
          <th>{{ $t('filters.list_actions') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="condition in formattedConditions"
          :key="condition.name"
          :class="{success: condition.new}"
        >
          <td>{{ condition.name }}</td>
          <td>{{ condition.formattedLastModified }}</td>
          <td>
            <button
              type="button"
              class="btn btn-default spaced"
              @click="retrieveCondition(condition.id)"
            >
              <span class="glyphicon glyphicon-ok"></span>
            </button>
            <button
              type="button"
              class="btn btn-default spaced"
              @click="editCondition(condition.id)"
            >
              <span class="glyphicon glyphicon-pencil"></span>
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="setConditionToDelete(condition)"
            >
              <span class="glyphicon glyphicon-trash"></span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <p v-else>
      {{ $t('filters.empty_list') }}
    </p>
    <pagination-component
      id="conditions-pagination"
      :current-page="currentPage"
      :page-count="pageCount"
      @select-page="retrieveConditions($event)"
    ></pagination-component>
  </div>
</template>

<script>
import {mapState, mapMutations, mapActions} from 'vuex';
import PaginationComponent from '../PaginationComponent';

export default {
  name: 'DisplayConditionsList',
  components: {
    PaginationComponent
  },
  computed: {
    ...mapState({
      displayConditions: state => state.displayModule.displayConditions,
      pageCount: state => state.displayModule.pageCount,
      currentPage: state => state.displayModule.currentPage,
      templateData: state => state.templateData
    }),
    formattedConditions: function () {
      return this.displayConditions.map(c => {
        const formattedDate = new Date();
        formattedDate.setTime(c.lastModified);
        c.formattedLastModified = `${formattedDate.toLocaleDateString(
          this.$t('filters.date_locale')
        )} ${formattedDate.toLocaleTimeString(this.$t('filters.date_locale'))}`;
        return c;
      });
    }
  },
  methods: {
    ...mapMutations('displayModule', [
      'setConditionToDelete',
      'setEditConditions',
      'setConditionToEdit'
    ]),
    ...mapActions(['retrieveDisplayCondition', 'getDisplayCondition']),
    ...mapActions('displayModule', ['retrieveDisplayConditions']),
    retrieveConditions(selectedPage) {
      this.retrieveDisplayConditions({
        sourceId: this.templateData.mergeTagsSource.id,
        page: selectedPage - 1
      });
    },
    retrieveCondition(id) {
      this.retrieveDisplayCondition({
        mergeTagsSource: this.templateData.mergeTagsSource.id,
        conditionId: id
      }).then(
        function () {
          this.$emit('condition-applied');
        }.bind(this)
      );
    },
    editCondition(id) {
      this.getDisplayCondition({
        mergeTagsSource: this.templateData.mergeTagsSource.id,
        conditionId: id
      }).then(
        function (displayCondition) {
          this.setConditionToEdit(displayCondition);
          this.setEditConditions(true);
        }.bind(this)
      );
    }
  }
};
</script>

<style scoped>
.spaced {
  margin-right: 1em;
}
td {
  text-align: left;
}
</style>
<style>
#conditions-pagination > .extra-pagination > div.sweet-modal {
  position: absolute;
  left: 300px;
  right: 0px;
  margin-left: 0;
  margin-right: 0px;
  width: 400px;
  overflow: clip;
}
</style>
